// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"91f5d0be","147":"4465a02f","152":"3bd8652f","198":"5c830e18","362":"a719ab9e","404":"3ac5f455","480":"cc4b9a94","541":"226ec405","579":"98a5aa46","732":"11b80bca","854":"d3b510e0"}[chunkId] + ".chunk.js";
};